import { Box } from "@mui/material";
import { Mail, Phone } from "lucide-react";
import { CareersFooter } from "../../services/cms/careersFooter";

const heading = { fontSize: "1.25rem", fontWeight: 600, margin: 0 };
const body = { fontSize: "0.875rem", lineHeight: 1.6, margin: 0 };
// Grey like the other careers sites' contact links. The page wraps content in
// .static-container .wrap, whose global rule makes every link yellow and is
// more specific than these styles, hence !important.
const contactLink = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.75rem",
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "#6b7280 !important",
  textDecoration: "none",
  "&:hover": { color: "#333 !important", textDecoration: "underline" },
};

// The equal opportunity statement and the Talent Acquisition contact, under a
// job page's share buttons, from the careers footer HR keeps in the CMS. The
// same section as the SOLS Group and SOLS Energy job pages, and in English in
// every locale, as the CMS text is.
const JobFooterInfo = ({ footer }: { footer: CareersFooter }) => (
  <Box
    sx={{
      display: "grid",
      // One column: the job column is too narrow for two side by side.
      gridTemplateColumns: "1fr",
      gap: 4,
      mt: 4,
      pt: 4,
      borderTop: "1px solid #eeeeee",
    }}
  >
    <Box sx={{ display: "grid", gap: 1, alignContent: "start" }}>
      <Box component="h3" sx={heading}>
        Equal Opportunity
      </Box>
      <Box component="p" sx={body}>
        {footer.equalOpportunity}
      </Box>
    </Box>

    <Box sx={{ display: "grid", gap: 1, alignContent: "start" }}>
      <Box component="h3" sx={heading}>
        Contact Us
      </Box>
      <Box component="p" sx={{ ...body, whiteSpace: "pre-line" }}>
        {footer.contactText}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: 1, lg: 3 },
          pt: 1,
        }}
      >
        <Box component="a" href={`mailto:${footer.email}`} sx={contactLink}>
          <Mail size={16} aria-hidden="true" /> {footer.email}
        </Box>
        <Box component="a" href={`tel:${footer.phoneHref}`} sx={contactLink}>
          <Phone size={16} aria-hidden="true" /> {footer.phoneDisplay}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default JobFooterInfo;
